export { RecipePairingsCard } from "./RecipePairingsCard";
export type {
	RecipePairingsCardProps,
	RecipePairingsCardRecipe
} from "./RecipePairingsCard";
